/* eslint no-param-reassign: "off", no-console: "off" */
const jobsStore = {
  state: {
    jobs: [],
    job: null
  },
  mutations: {
    fetchJobs(state, payload) {
      state.jobs = payload;
    },
    fetchJob(state, payload) {
      state.job = payload;
    }
  },
  actions: {
    /**
     * Fetches a list of jobs
     * @param {*} param0 
     * @param {Object} payload - Object containing paging, sorting, filters
     */
    // eslint-disable-next-line no-unused-vars
    async fetchJobs({ commit }, payload) {
      try {
        const res = await fetch('/v2/jobs');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchJobs', data);
        return true;        
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    /**
     * Fetches an individual job
     * @param {*} param0 
     * @param {string} payload - Individual remote Id
     */
    async fetchJob({ commit }, payload) {
      try {
        const res = await fetch(`/v2/jobs/${payload.id}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchJob', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  },
  getters: {

  }
}
export default jobsStore;
